import { apiSlice } from '../../api/apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'Account/Authenticate',
        method: 'POST',
        credentials: 'include',
        body: { ...credentials }
      })
    }),
    logout: builder.mutation({
      query: () => ({
        url: 'Account/Logout',
        method: 'POST',
        credentials: 'include'
      })
    }),
    getClassicLoginPage: builder.mutation({
      query: () => ({
        url: 'Account/GetClassicLoginPage',
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    refresh: builder.mutation({
      query: () => ({
        url: 'Account/RefreshToken',
        method: 'POST',
        credentials: 'include'
      })
    }),
    classicLogin: builder.mutation({
      query: (credentials) => ({
        url: 'Account/ClassicCastleAuthenticate',
        method: 'POST',
        body: { ...credentials },
        credentials: 'include'
      })
    }),
    forgotPassword: builder.mutation({
      query: (accountEmail) => ({
        url: 'Account/ForgotPassword/' + accountEmail,
        method: 'POST'
      })
    }),
    saveAssignmentLinkNote: builder.mutation({
      query: (options) => ({
        url: `Assignment/SaveAssignmentLinkNote?note=${options.note}&urlGuid=${options.urlGuid}`,
        method: 'POST'
      })
    }),
    getForgotPasswordUser: builder.query({
      query: (resetToken) => ({
        url: 'Account/GetForgotPasswordUser/' + resetToken,
        method: 'GET'
      })
    }),
    updateUserPassword: builder.mutation({
      query: (newPasswordDetails) => ({
        url: 'Account/UpdateUserPassword',
        method: 'POST',
        body: { ...newPasswordDetails }
      })
    }),
    getNews: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetNews',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getMessageCount: builder.mutation({
      query: () => ({
        url: 'Alert/GetAlertCount',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAlerts: builder.mutation({
      query: (options) => ({
        url: `Alert/AllAlerts/${options.skip}/${options.take}`,
        params: {
          viewType: options.viewType,
          orderBy: options.orderBy,
          searchText: options.searchText
        },
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAvailableSchoolYears: builder.mutation({
      query: () => ({
        url: 'SchoolYear/GetAvailableSchoolYears',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllStates: builder.mutation({
      query: () => ({
        url: 'State/GetAllStates',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllSchools: builder.mutation({
      query: () => ({
        url: 'School/GetAllSchools',
        method: 'GET',
        credentials: 'include'
      })
    }),
    generateOneTimeCode: builder.mutation({
      query: () => ({
        url: 'School/GenerateOneTimeCode',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateAdditonalOptionsComment: builder.mutation({
      query: (options) => {
        const comment = options.comment;
        return {
          url: `School/${options.schoolId}/UpdateComment?comment=${comment}`,
          method: 'PUT',
          credentials: 'include'
        };
      }
    }),
    updateSchoolYear: builder.mutation({
      query: (year) => ({
        url: 'SchoolYear/YearChange?year=' + year,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getschoolInfo: builder.mutation({
      query: (schoolId) => ({
        url: `School/${schoolId}/Info`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateState: builder.mutation({
      query: (stateId) => ({
        url: 'State/UpdateStateChange?stateId=' + stateId,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getStudents: builder.mutation({
      query: () => ({
        url: 'Student/GetAllUsers',
        params: { searchString: '' },
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllCourseList: builder.mutation({
      query: () => ({
        url: 'Course/GetAllCourseList',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getDBQCourses: builder.mutation({
      query: () => ({
        url: 'Course/DBQCourses',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllCustomCourses: builder.mutation({
      query: () => ({
        url: 'Course/custom',
        method: 'GET',
      })
    }),
    getAssignmentFolders: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAssignmentFolders',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAssignmentStatus: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAllAssignmentStatus',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAssignedVia: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAllAssignedVia',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentsByFilter: builder.mutation({
      query: (options) => {
        const { AssignmentStatus, CourseId, FolderId, AssignedVia } = options;
        let url = `Assignment/GetAssignmentsByFilter/${options.skip}/${options.take}?`;
        if (CourseId) url += `CourseId=${CourseId}&`;
        if (FolderId) url += `FolderId=${FolderId}&`;
        if (AssignmentStatus && AssignmentStatus.length > 0) {
          AssignmentStatus.forEach((assignmentId, index) => {
            url += `AssignmentStatus=${assignmentId}${AssignmentStatus.length !== index ? '&' : ''
              }`;
          });
        }
        if (AssignedVia && AssignedVia.length > 0) {
          AssignedVia.forEach((assignedViaId, index) => {
            url += `AssignedVia=${assignedViaId}${AssignedVia.length !== index + 1 ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'GET',
          params: {
            SearchText: options.SearchText,
            sort: options.sort,
            IsSearch: options.IsSearch
          },
          credentials: 'include'
        };
      }
    }),
    getPublicAssignments: builder.mutation({
      query: (options) => ({
        url: `Assignment/GetPublicAssignments/${options.skip}/${options.take}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicAssignmentProperties: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/properties`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicSet: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    deletePublicAssignment: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    deleteCollaborator: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Collaborator/${options.collaboratorId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    maintenanceNotification: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetSystemNotifications',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateEmailId: builder.mutation({
      query: (options) => ({
        url: `Student/UpdateMailId?email=${options.email}&password=${options.password}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getClasses: builder.mutation({
      query: () => ({
        url: 'Class/GetClasses',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStudentsDetails: builder.mutation({
      query: (options) => {
        const { aIds, classId, skip, take } = options;
        let url = 'Student/GetStudents?';
        if (classId) url += `classId=${classId}&`;
        if (skip) url += `skip=${skip}&`;
        if (take) url += `skip=${take}&`;
        if (aIds && aIds.length > 0) {
          aIds.forEach((assignmentId, index) => {
            url += `assignmentIds=${assignmentId}${aIds.length !== index ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'GET',
          credentials: 'include'
        };
      }
    }),
    getAssignmentLinks: builder.query({
      query: () => ({
        url: 'Assignment/GetAssignmentLinks',
        method: 'GET'
      })
    }),
    deleteAssignmentLinks: builder.mutation({
      query: (urlGuid) => ({
        url: `Assignment/DeleteAssignmentLink/${urlGuid}`,
        method: 'DELETE'
      })
    }),
    getGoogleClassroomClasses: builder.query({
      query: () => ({
        url: '/Class/GetGoogleClassroomClasses',
        method: 'GET'
      })
    }),
    processToken: builder.mutation({
      query: (options) => ({
        url: `/Class/ProcessToken?url=${options.url}`,
        method: 'GET'
      })
    }),
    navigateToClassicCastle: builder.mutation({
      query: (navRequest) => ({
        url: '/Account/NavigateToClassicCastle',
        method: 'POST',
        body: { ...navRequest },
        credentials: 'include'
      })
    }),
    getClassId: builder.mutation({
      query: () => ({
        url: 'Class/ClassId',
        method: 'GET',
        credentials: 'include'
      })
    }),
    addClassId: builder.mutation({
      query: (options) => ({
        url: `Class/ClassId/${options.classId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getFilters: builder.mutation({
      query: () => ({
        url: 'Assignment/GetFilters',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getEmail: builder.mutation({
      query: () => ({
        url: 'Student/GetEmail',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getJwtforAha: builder.mutation({
      query: () => ({
        url: 'Account/GetTokenForAhaWidgets',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getSystemVersion: builder.mutation({
      query: () => ({
        url: 'System/GetVersionInfo',
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    loginWithGoogle: builder.mutation({
      query: (token) => ({
        url: `Account/LoginWithGoogle/${token}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    authenticateSuperAdmin: builder.mutation({
      query: (adminPassword) => ({
        url: `Account/AuthenticateSuperAdmin/${adminPassword}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    validateSSO: builder.mutation({
      query: () => ({
        url: 'ValidateSSO',
        method: 'GET',
        credentials: 'include'
      })
    }),
    InitiateSiteSwitchLog: builder.mutation({
      query: () => ({
        url: 'Account/InitiateSiteSwitchLog',
        method: 'POST',
        credentials: 'include'
      })
    })
  })
});

export const {
  useSaveAssignmentLinkNoteMutation,
  useLoginMutation,
  useLogoutMutation,
  useClassicLoginMutation,
  useRefreshMutation,
  useForgotPasswordMutation,
  useGetForgotPasswordUserQuery,
  useUpdateUserPasswordMutation,
  useGetNewsMutation,
  useGetMessageCountMutation,
  useGetAllAlertsMutation,
  useGetAvailableSchoolYearsMutation,
  useGetAllStatesMutation,
  useGetAllSchoolsMutation,
  useGenerateOneTimeCodeMutation,
  useUpdateAdditonalOptionsCommentMutation,
  useUpdateSchoolYearMutation,
  useGetAllCourseListMutation,
  useGetDBQCoursesMutation,
  useGetAllCustomCoursesMutation,
  useGetAssignmentFoldersMutation,
  useGetAllAssignmentStatusMutation,
  useGetAllAssignedViaMutation,
  useGetAssignmentsByFilterMutation,
  useGetschoolInfoMutation,
  useUpdateStateMutation,
  useGetStudentsMutation,
  useGetPublicAssignmentsMutation,
  useGetPublicAssignmentPropertiesMutation,
  useGetPublicSetMutation,
  useDeletePublicAssignmentMutation,
  useMaintenanceNotificationMutation,
  useUpdateEmailIdMutation,
  useGetClassesMutation,
  useGetStudentsDetailsMutation,
  useLazyGetAssignmentLinksQuery,
  useDeleteAssignmentLinksMutation,
  useLazyGetGoogleClassroomClassesQuery,
  useNavigateToClassicCastleMutation,
  useGetClassIdMutation,
  useAddClassIdMutation,
  useGetFiltersMutation,
  useDeleteCollaboratorMutation,
  useGetClassicLoginPageMutation,
  useGetEmailMutation,
  useGetJwtforAhaMutation,
  useGetSystemVersionMutation,
  useLoginWithGoogleMutation,
  useAuthenticateSuperAdminMutation,
  useValidateSSOMutation,
  useProcessTokenMutation,
  useInitiateSiteSwitchLogMutation
} = authApi;
